import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';
import { NotAuthComponent } from 'projects/shared/src/pages/not-auth/not-auth.component';
import { ErrorComponent } from 'projects/shared/src/pages/error/error.component';

const routes: Routes = [
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      { path: '', redirectTo: (localStorage.getItem('baseRoute') || ''), pathMatch: 'full' },
      { path: 'categories', loadChildren: () => import('./features/categories/categories.module').then(m => m.CategoriesModule) },
      { path: 'entities', loadChildren: () => import('./features/entities/entities.module').then(m => m.EntitiesModule) },
      { path: 'roles', loadChildren: () => import('./features/roles/roles.module').then(m => m.RolesModule) },
      { path: 'users', loadChildren: () => import('./features/system-users/system-users.module').then(m => m.SystemUsersModule) },
      { path: 'user-profile', loadChildren: () => import('./features/user-profile/user-profile.module').then(m => m.UserProfileModule) },
      { path: 'regulations', loadChildren: () => import('./features/regulations/regulations.module').then(m => m.RegulationsModule) },
      { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
      // { path: 'entityProfile', component: EntityDetailsComponent },
      { path: 'complaints-settings', loadChildren: () => import('./features/complaints-settings/complaints-settings.module').then(m => m.ComplaintsSettingsModule) },
      { path: 'complaints', loadChildren: () => import('./features/complaints/complaints.module').then(m => m.ComplaintsModule) }
    ]
  },
  { path: 'notAuthorized', component: NotAuthComponent },
  { path: 'notFound', component: ErrorComponent },
  { path: '**', component: ErrorComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
